/**
 * A shown value that is not a copy target. `data-field` names it the way a `CopyValue`'s label
 * names its value, so the e2e suite can read it. A truncated display keeps the full value on hover.
 */
export function PlainValue({
    value,
    label,
    className,
    truncated = false,
}: {
    value: string | number;
    label: string;
    className?: string;
    truncated?: boolean;
}) {
    return (
        <span data-field={label} title={truncated ? String(value) : undefined} className={className}>
            {value}
        </span>
    );
}
